import React from 'react'
import { SelectArrayInputProps } from 'types/common'
import KSelectArrayInput from 'ui-shared/WrappedInputs/TailoredFilters/KSelectArrayInput'
import LocalizedFieldWithChoices from './LocalilzedFieldWithChoices'

const LocalizedSelectArrayInput: React.FC<SelectArrayInputProps> = (props) => (
  <LocalizedFieldWithChoices {...props}>
    <KSelectArrayInput source={props.source} />
  </LocalizedFieldWithChoices>
)

export default LocalizedSelectArrayInput
